var map = {
	"./arrow-down.svg": "Peom",
	"./arrow-left.svg": "INtk",
	"./close-dialog.svg": "KbMm",
	"./edit-1.svg": "/Bfe",
	"./edit.svg": "ql+d",
	"./file-csv.svg": "KzHg",
	"./file-image.svg": "VgOL",
	"./file-markdown.svg": "Glib",
	"./file-pdf.svg": "jMQq",
	"./file-ppt.svg": "BfPc",
	"./file-radio.svg": "fcOn",
	"./file-txt.svg": "6hyF",
	"./file-video.svg": "ST7c",
	"./file-word.svg": "e8XR",
	"./file-xls.svg": "CQQC",
	"./file-zip.svg": "yu1U",
	"./file.svg": "fQ0v",
	"./no-data.svg": "0gbf",
	"./power.svg": "aUH0",
	"./satisfaction-face-laugh-active.svg": "JKPJ",
	"./satisfaction-face-laugh.svg": "Cqwg",
	"./satisfaction-face-normal-active.svg": "zdnb",
	"./satisfaction-face-normal.svg": "SntI",
	"./satisfaction-face-rage-active.svg": "Ir7B",
	"./satisfaction-face-rage.svg": "Yrhe",
	"./satisfaction-face-sad-active.svg": "g/Y7",
	"./satisfaction-face-sad.svg": "n05Y",
	"./satisfaction-face-smile-active.svg": "1UHJ",
	"./satisfaction-face-smile.svg": "fVQp",
	"./satisfaction-love-1-active.svg": "MFup",
	"./satisfaction-love-10-active.svg": "SHG5",
	"./satisfaction-love-2-active.svg": "OqLu",
	"./satisfaction-love-3-active.svg": "xIW1",
	"./satisfaction-love-4-active.svg": "aan7",
	"./satisfaction-love-5-active.svg": "mD7N",
	"./satisfaction-love-6-active.svg": "m41B",
	"./satisfaction-love-7-active.svg": "irHB",
	"./satisfaction-love-8-active.svg": "EZWx",
	"./satisfaction-love-9-active.svg": "2+ZT",
	"./satisfaction-love.svg": "Zf0a",
	"./satisfaction-option.svg": "eljV",
	"./satisfaction-star-active.svg": "sxF/",
	"./satisfaction-star.svg": "M8oE",
	"./satisfaction-thumb-1-active.svg": "VaIY",
	"./satisfaction-thumb-1.svg": "DynP",
	"./satisfaction-thumb-2-active.svg": "2Lyq",
	"./satisfaction-thumb-2.svg": "j0gh",
	"./send.svg": "0zCS",
	"./service.svg": "nCjf",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 6 7